var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.501 2.99902H6.50086C4.57096 2.99902 3.00098 4.56901 3.00098 6.49908V23.4992C3.00098 25.4291 4.57096 26.9991 6.50103 26.9991H23.5012C25.4312 26.9991 27.0012 25.4291 27.0012 23.4991V6.49891C27.0011 4.56901 25.4311 2.99902 23.501 2.99902ZM23.0011 16.499C23.0011 16.7751 22.7771 16.9991 22.5011 16.9991H12.0011V19.499C12.0011 19.688 11.8941 19.861 11.725 19.946C11.654 19.981 11.577 19.9991 11.501 19.9991C11.395 19.9991 11.2891 19.9651 11.201 19.8992L7.20106 16.8992C7.075 16.8051 7.00101 16.6561 7.00101 16.499C7.00101 16.342 7.075 16.193 7.20106 16.0991L11.201 13.0991C11.352 12.9851 11.5561 12.968 11.724 13.0521C11.8941 13.1371 12.0011 13.31 12.0011 13.4991V15.999H22.0009V10.4991C22.0009 10.2231 22.2249 9.99908 22.501 9.99908C22.777 9.99908 23.001 10.2231 23.001 10.4991L23.0011 16.499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/Enter.c9b46a5892a24c1eece1cc02dbbbb6f8.svg";
export { ForwardRef as ReactComponent };